query GetNewsItem($id: ID!) {
  newsItem(id: $id) {
    id
    eventType {
      id
      name
    }
    title
    date
    tags
    showFrom
    showTo
    url
    order
    targetAudience {
      id
    }
    active
  }
}
